module.exports = __webpack_public_path__ + "img/cuti.3b194887.png";